import { CombinedQuestionStats } from "../view-survey.types";
import { useMemo } from "react";
import { AnswerSource, type AnswerStats } from "../../../redux/survey/survey.types";
import { maxAnswerPercentage, sortAnswers } from "./results-question.helpers";

function toAnswerStatsArray(
  answers: AnswerStats[] | Record<string, AnswerStats> | null | undefined
): AnswerStats[] {
  if (answers == null) {
    return [];
  }
  if (Array.isArray(answers)) {
    return answers;
  }
  if (typeof answers === 'object') {
    return Object.values(answers);
  }
  return [];
}

/** Always use All; AI/Human toggle removed - unified results only */
export const useResultsQuestion = (question: CombinedQuestionStats, _aiMaxCompletes?: number, _humanMaxCompletes?: number) => {
  const { freeformAnswers } = question;
  const answers = useMemo(() => toAnswerStatsArray(question.answers), [question.answers]);
  const hasImageAnswers = answers.some(answer => answer.imageUrl);
  const answerFilter = AnswerSource.All;
  const showFilters = false;

  const { maxPercentage, sortedAnswers } = useMemo(() => {
    const sorted = question.freeformAnswers === undefined ? sortAnswers(answers, answerFilter) : [];
    return { maxPercentage: maxAnswerPercentage(answers, answerFilter), sortedAnswers: sorted };
  }, [answers, question.freeformAnswers, answerFilter]);

  return { hasImageAnswers, answerFilter, showFilters, maxPercentage, sortedAnswers, freeformAnswers };
};
